import styled from 'foundations-theming/utils';
import { createPortal } from 'react-dom';
import { useEffect, useCallback, useRef, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { URANUS_LAYER } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TD_ELEMENT_TYPE = 'TD';
const StyledTooltip = styled.div.withConfig({
  displayName: "CommentModeCursorTooltip__StyledTooltip",
  componentId: "in8dt7-0"
})([".hs-private.hs-private.hs-private &{display:none;z-index:", ";position:fixed;width:fit-content;padding:", " ", ";color:", ";background-color:", ";border-radius:", ";}"], URANUS_LAYER, ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.color['text-primary-on-fill-default'], ({
  theme
}) => theme.color['fill-accent-neutral-default'], ({
  theme
}) => theme.borderRadius['100']);
const PopoverArrow = styled.div.withConfig({
  displayName: "CommentModeCursorTooltip__PopoverArrow",
  componentId: "in8dt7-1"
})([".hs-private.hs-private.hs-private &{background-color:", ";transform:rotate(45deg);width:", ";height:", ";position:absolute;left:-", ";top:", ";}"], ({
  theme
}) => theme.color['fill-accent-neutral-default'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['300']);
export default function CommentModeCursorTooltip({
  elementName = 'hubspot',
  portalClassnameWrapper
}) {
  const tooltipRef = useRef(undefined);
  const onMouseMove = useCallback(e => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.style.left = `${e.pageX + 30 - window.scrollX}px`;
      tooltip.style.top = `${e.pageY - 20 - window.scrollY}px`;
      const target = e.target && e.target.nodeName === TD_ELEMENT_TYPE ? e.target.parentNode : e.target;
      tooltip.style.display = target && target.classList && target.classList.contains('commentable-area') && !target.classList.contains('commenting-commentable-area') ? 'block' : 'none';
    }
  }, []);
  const onMouseDown = useCallback(() => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.style.display = 'none';
    }
  }, []);
  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mousedown', onMouseDown);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [onMouseDown, onMouseMove]);
  const appElement = document.getElementsByClassName(elementName);
  const cursorTooltip = useMemo(() => appElement.length > 0 ? /*#__PURE__*/createPortal(portalClassnameWrapper ?
  /*#__PURE__*/
  // @bend-expect trellis-tokenized no styling usage
  _jsx("div", {
    className: portalClassnameWrapper,
    children: /*#__PURE__*/_jsxs(StyledTooltip, {
      "data-test-id": "commentable-tooltip"
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      ref: tooltipRef,
      children: [/*#__PURE__*/_jsx(PopoverArrow, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "collaborationSidebar.modals.commentMode.placeCommentTooltip"
      })]
    })
  }) : /*#__PURE__*/_jsxs(StyledTooltip, {
    "data-test-id": "commentable-tooltip"
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    ,
    ref: tooltipRef,
    children: [/*#__PURE__*/_jsx(PopoverArrow, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "collaborationSidebar.modals.commentMode.placeCommentTooltip"
    })]
  }), appElement[0]) : null, [appElement, portalClassnameWrapper]);
  return cursorTooltip;
}